/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs */

const en_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load folder structure`)
};

const fr_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec du chargement de la structure des dossiers`)
};

const de_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordnerstruktur konnte nicht geladen werden`)
};

const it_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare la struttura delle cartelle`)
};

const ru_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить структуру папок.`)
};

const es_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar la estructura de la carpeta`)
};

const zh_cn2_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载文件夹结构失败`)
};

const ja_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ構造の読み込みに失敗しました`)
};

const hi_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर संरचना लोड करने में विफल`)
};

const pt_pt2_explorer_nav_load_folder_structure_failed_toast = /** @type {(inputs: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar a estrutura de pastas`)
};

/**
* | output |
* | --- |
* | "Failed to load folder structure" |
*
* @param {Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_load_folder_structure_failed_toast = /** @type {((inputs?: Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Load_Folder_Structure_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "de") return de_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "it") return it_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "es") return es_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_nav_load_folder_structure_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_load_folder_structure_failed_toast(inputs)
	return en_explorer_nav_load_folder_structure_failed_toast(inputs)
});